import { Paper, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { ReactComponent as LineIcon } from "../../../../assets/svg/Line.svg";
import { formattedAmount } from "../../../../utils/CommonFunction";
import rawStyles from "../../styles";
import { useTheme } from "@emotion/react";

function Statistis({ details }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const styles = rawStyles(isMobile);

  const stats = [
    { label: "Project Type", value: details?.project_type },
    {
      label: "Budget",
      value: formattedAmount(
        details?.proposal_status !== "ongoing"
          ? details?.budget
          : details?.budget_without_commission
      ),
    },
  ];

  return (
    <>
      <div style={styles.rowFlex}>
        {stats?.map((stat, index) => (
          <div style={{ width: "100%" }} key={index}>
            <Paper style={styles.stats_section}>
              {index !== 0 ? <LineIcon /> : null}
              <div style={{ padding: index === 0 ? "1vh 0vw" : "1vh 4vw" }}>
                <Typography style={styles.stats_label}>
                  {stat?.label}
                </Typography>
                <Typography style={styles.stats_value}>
                  {stat.value ? stat?.value : "---"}
                </Typography>
              </div>
            </Paper>
          </div>
        ))}
      </div>
    </>
  );
}

export default Statistis;
